const routes = [
  {
    path: '/couponGoodsList',
    name: 'couponGoodsList',
    meta: {
      title: '优惠商品',
      login: false,
    },
    component: () => import(/* webpackChunkName: 'coupon' */ './page/couponGoodsList.vue'),
  },
    {
    path: '/couponAllGoodsList',
    name: 'couponAllGoodsList',
    meta: {
      title: '优惠商品',
      login: false,
    },
    component: () => import(/* webpackChunkName: 'coupon' */ './page/couponAllGoodsList.vue'),
  },
];

export default routes;
